/**
 * Realce do termo casado num rótulo de resultado.
 *
 * Usa a variante `.term-hit` do Design System (criada nesta frente — ADR-141
 * Caso B). Ela é **neutra**, não âmbar, e a razão é de leitura: o âmbar já está
 * falado na paleta — ele é a linha em foco. Dois âmbares na mesma lista fazem o
 * olho perder onde está o cursor, e o realce neutro ainda sobrevive DENTRO da
 * linha em foco, que já tem fundo âmbar claro.
 *
 * O casamento ignora acento e caixa, igual à busca: quem digita «mari» tem que
 * ver o realce em «Mariana» e em «Máriotécnico».
 */
import { foldTerm } from './fold-term';

export function HighlightTerm({ text, term }: { text: string; term: string }): JSX.Element {
  const folded = foldTerm(term);
  if (folded.length === 0) return <>{text}</>;

  // Compara sobre a versão dobrada, mas RECORTA do texto original — assim o
  // realce preserva acento e caixa do que está na tela.
  const foldedText = foldTerm(text);
  const parts: JSX.Element[] = [];
  let cursor = 0;
  let guard = 0;

  while (guard < 50) {
    guard += 1;
    const at = foldedText.indexOf(folded, cursor);
    if (at === -1) break;
    if (at > cursor) parts.push(<span key={`p${String(cursor)}`}>{text.slice(cursor, at)}</span>);
    parts.push(
      <mark key={`h${String(at)}`} className="term-hit">
        {text.slice(at, at + folded.length)}
      </mark>,
    );
    cursor = at + folded.length;
  }

  if (parts.length === 0) return <>{text}</>;
  if (cursor < text.length) parts.push(<span key="tail">{text.slice(cursor)}</span>);
  return <>{parts}</>;
}
